import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledWalletAwardTile = styled.article`
  width: 100%;
  min-width: 0;
  flex: 1 0 0;

  @media ${baseVariables.mediaQuery.md} {
    min-width: ${toRem(280)};
  }

  .wallet-award-tile__button {
    width: 100%;
    padding: 0;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
    display: block;
  }

  .wallet-award-tile__button:focus-visible {
    outline: ${toRem(2)} solid ${baseVariables.color['base10']};
    outline-offset: ${toRem(2)};
    border-radius: ${toRem(14)};
  }

  .wallet-award-tile__card {
    min-height: ${toRem(88)};
    background: ${baseVariables.color['base20'] || '#FFFFFF'};
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    border-radius: ${toRem(14)};
    box-shadow: 0 ${toRem(2)} ${toRem(10)} 0 rgba(0, 0, 0, 0.07);
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
    padding: ${toRem(16)} ${toRem(8)} ${toRem(16)} ${toRem(16)};
  }

  .wallet-award-tile__media {
    width: ${toRem(48)};
    height: ${toRem(48)};
    border-radius: ${toRem(8)};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: clip;
  }

  .wallet-award-tile__media--icon {
    background: ${baseVariables.color['neutral10'] || '#F8F8F8'};
    padding: ${toRem(12)};
  }

  .wallet-award-tile__media--image {
    background: transparent;
    padding: 0;
  }

  .wallet-award-tile__media-icon {
    font-size: ${toRem(24)};
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .wallet-award-tile__media-placeholder {
    width: ${toRem(24)};
    height: ${toRem(24)};
    border-radius: ${toRem(4)};
    background: ${baseVariables.color['neutral20']};
  }

  .wallet-award-tile__media-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .wallet-award-tile__content {
    min-width: 0;
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .wallet-award-tile__eyebrow {
    color: ${baseVariables.color['neutral40']};
    font-size: ${toRem(12)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1;
    text-transform: uppercase;
    padding-bottom: ${toRem(8)};
  }

  .wallet-award-tile__title {
    color: ${baseVariables.color['base10']};
    font-size: ${toRem(14)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1.25;
    padding-bottom: ${toRem(4)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .wallet-award-tile__expiration {
    color: ${baseVariables.color['neutral40']};
    font-size: ${toRem(12)};
    line-height: 1.5;
    padding-bottom: ${toRem(4)};
  }

  .wallet-award-tile__status {
    position: relative;
    height: ${toRem(20)};
    padding: ${toRem(4)} ${toRem(8)};
    gap: ${toRem(4)};
    border-radius: ${toRem(4)};
    overflow: clip;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${baseVariables.color['base10']};
    font-size: ${toRem(12)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1.2;
  }

  .wallet-award-tile__status-icon,
  .wallet-award-tile__status-icon::before {
    font-size: ${toRem(16)};
    line-height: 1;
    color: ${baseVariables.color['base10']} !important;
  }

  .wallet-award-tile__status-text {
    line-height: 1.2;
    color: ${baseVariables.color['base10']};
  }

  .wallet-award-tile__status--success {
    background: rgba(71, 125, 0, 0.1);
  }

  .wallet-award-tile__status--neutral {
    background: rgba(196, 196, 196, 0.18);
  }

  .wallet-award-tile__status--info {
    background: rgba(196, 196, 196, 0.18);
    color: var(--Color-Set-brand-fg-color, #1c1c1c);
  }

  .wallet-award-tile__status--info .wallet-award-tile__status-text {
    color: var(--Color-Set-brand-fg-color, #1c1c1c);
  }

  .wallet-award-tile__status--info .wallet-award-tile__status-icon,
  .wallet-award-tile__status--info .wallet-award-tile__status-icon::before {
    color: var(--Color-Set-brand-fg-color, #1c1c1c) !important;
  }

  .wallet-award-tile__chevron,
  .wallet-award-tile__chevron::before,
  .wallet-award-tile__chevron .icon-decorative,
  .wallet-award-tile__chevron .icon-decorative::before {
    color: ${baseVariables.color['base10']} !important;
    font-size: ${toRem(24)};
    line-height: 1;
  }

  .wallet-award-tile__chevron {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
